/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { InjectionToken, Signal, inject } from '@angular/core';
import { OSKLocaleService } from '../services/locale.service';

/**
 * An injection token that returns the currently selected locale {@link Signal} from the {@link OSKLocaleService}
 */
export const OSKLocaleToken: InjectionToken<Signal<string>> = new InjectionToken(
  'Signal for the current locale',
  {
    providedIn: 'root',
    factory: (): Signal<string> => {
      const localeService = inject(OSKLocaleService);
      return localeService.locale;
    }
  }
);
